import { ValidateFormResponse } from "../interfaces/ValidateFormResponse.interface";
import { i18n } from "./helpers/translation/i18n";


/**
 * [validateForm Validate a form]
 * @param {dom element} form [The form object to validate]
 * @return {object} true if valid or an error object if invalid
 */
export function validateForm(form: HTMLFormElement): ValidateFormResponse {
    const requiredInput = [...form.querySelectorAll("input[required], textarea[required], select[required]")] as Array<HTMLInputElement>;

    const errors = {} as Record<string, unknown>;

    requiredInput.forEach((element: HTMLInputElement) => {
        let value = "";
        let label = "";
        const name = element.getAttribute("name");

        if(element.type !== "radio" && element.type !== "checkbox") {
            value = element.value;

            const elementLabel = element.dataset.label;
            if (elementLabel) {
                label = elementLabel;
            }
        } else {
            const elementLabel = element.getAttribute("label");
            if (elementLabel) {
                label = elementLabel;
            }

            if (name) {
                const inputs = document.getElementsByName(name) as NodeListOf<HTMLInputElement>;

                const inputGroup = document.querySelector(`[data-name='${name}']`) as HTMLInputElement;

                if (inputGroup) {
                    const elementLabel = inputGroup.dataset.label;
                    if (elementLabel) {
                        label = elementLabel;
                    }
                }

                if(inputs.length > 0) {
                    for(let index = 0; index < inputs.length; index++) {
                        if(inputs[index].checked) {
                            value = inputs[index].value;
                            index = inputs.length + 1;
                        }
                    }
                }
            }
        }

        if (name) {
            if(value.length === 0) {
                errors[name] = `${label} ${i18n.t("is_required")}`;
            }
        }
    });

    if(Object.keys(errors).length === 0 && errors.constructor === Object) {
        return {
            "value": true,
            "errors": ""
        };
    } else {
        return {
            "value": false,
            "errors": errors
        };
    }
}
